import { render, staticRenderFns } from "./ip-mgr.vue?vue&type=template&id=177ff216&scoped=true"
import script from "./ip-mgr.vue?vue&type=script&lang=js"
export * from "./ip-mgr.vue?vue&type=script&lang=js"
import style0 from "./ip-mgr.vue?vue&type=style&index=0&id=177ff216&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177ff216",
  null
  
)

export default component.exports